/**
 * The CSV reader behind "Importar histórico" (`D201`). RFC 4180 — quoted
 * fields, doubled quotes, line breaks inside quotes, CRLF — plus the two
 * things real exports do that the RFC does not: a byte-order mark at the
 * start, and a SEMICOLON delimiter, which Strong writes on a phone whose
 * locale uses the comma as its decimal separator. The delimiter is read off
 * the header line, outside quotes.
 *
 * Pure: a string in, rows of strings out. Blank lines are dropped.
 */

const BOM = "﻿";

/** `,` or `;`, whichever the header line uses more of outside quotes. */
export function detectDelimiter(text: string): "," | ";" {
  let commas = 0;
  let semicolons = 0;
  let quoted = false;
  for (const char of text) {
    if (char === '"') {
      quoted = !quoted;
    } else if (!quoted && (char === "\n" || char === "\r")) {
      break;
    } else if (!quoted && char === ",") {
      commas += 1;
    } else if (!quoted && char === ";") {
      semicolons += 1;
    }
  }
  return semicolons > commas ? ";" : ",";
}

export function parseCsv(input: string): string[][] {
  const text = input.startsWith(BOM) ? input.slice(1) : input;
  const delimiter = detectDelimiter(text);
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let quoted = false;
  const endRow = () => {
    row.push(field);
    field = "";
    if (row.length > 1 || row[0] !== "") {
      rows.push(row);
    }
    row = [];
  };
  for (let index = 0; index < text.length; index += 1) {
    const char = text[index] as string;
    if (quoted) {
      if (char === '"' && text[index + 1] === '"') {
        field += '"';
        index += 1;
      } else if (char === '"') {
        quoted = false;
      } else {
        field += char;
      }
    } else if (char === '"') {
      quoted = true;
    } else if (char === delimiter) {
      row.push(field);
      field = "";
    } else if (char === "\n") {
      endRow();
    } else if (char !== "\r") {
      field += char;
    }
  }
  if (field !== "" || row.length > 0) {
    endRow();
  }
  return rows;
}

/** The header row as a lookup of lower-cased, trimmed column names. */
export function headerIndex(header: readonly string[]): Map<string, number> {
  const index = new Map<string, number>();
  for (const [position, name] of header.entries()) {
    index.set(name.trim().toLowerCase(), position);
  }
  return index;
}
